import { API_GET_DOMAINS } from '@/api/apiRoutes'
import api from '@/lib/api'
import { IDnsDomain } from '@/types/DnsDomain'

export const getNstypes = async () => {
  try {
    const { data } = await api.get<IDnsDomain[]>(`${API_GET_DOMAINS}ns_type`)

    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
